<script lang="ts">
    import { sendUIInteractionAnalyticsEvent } from "@app/services/analytics/analytics-send-event";

    import ImagesBrowser from "./ImagesBrowser.svelte";

    let open = false;

    let images = [];
    let imageToShowIndex: number;
    function toggleModal() {
        open = !open;

        sendUIInteractionAnalyticsEvent({
            action: "show-image-gallery",
            label: open ? "open" : "close",
        });
    }

    function handleImageClick(event: Event) {
        const button = event.currentTarget as HTMLButtonElement;
        imageToShowIndex = parseInt(button.dataset["imageindex"] || "0");
        toggleModal();
    }

    const imageContainers = [
        ...document.querySelectorAll<HTMLButtonElement>("button.glosbe-image"),
    ];
    imageContainers.forEach((imageContainer, index) => {
        let url: string | undefined;
        let isAdult: boolean = false;

        const caption = imageContainer.dataset["caption"] || "";
        const imageId = imageContainer.dataset["imageId"];
        const credits = imageContainer.dataset["credits"] || "";

        if (imageContainer.dataset["adult"] === "true") {
            isAdult = true;
        } else {
            const imgElement = imageContainer
                .getElementsByTagName("img")
                .item(0);
            if (imgElement && imgElement.src) {
                url = imgElement.src.replace(/.*\//, "");
            }
        }
        imageContainer.addEventListener("click", handleImageClick);
        images.push({ url, caption, isAdult, imageId, credits });
    });
</script>

{#if open}
    <ImagesBrowser {images} {imageToShowIndex} onClose={toggleModal} />
{/if}
